// 'trial' adds the trial badge and the "1 video, up to 5 minutes" line; 'paid' is the same intro without them.
export type RecordingIntroVariant = 'paid' | 'trial';

type RecordingIntroVariantInput = {
  hasTrialPlan: boolean;
  isPaidSpace: boolean;
  isWhiteLabel: boolean;
};

/** A paid space wins over a user-level trial balance; free plans and white-label builds get no intro. */
export const getRecordingIntroVariant = ({
  hasTrialPlan,
  isPaidSpace,
  isWhiteLabel,
}: RecordingIntroVariantInput): null | RecordingIntroVariant => {
  if (isWhiteLabel) return null;
  if (isPaidSpace) return 'paid';

  return hasTrialPlan ? 'trial' : null;
};
